function updateCountdown() {
  const now = new Date();
  const cutoffTime = new Date(now);
  cutoffTime.setHours(15, 0, 0, 0); // Set cutoff time to 2:00 PM

  if (now > cutoffTime) {
    cutoffTime.setDate(cutoffTime.getDate() + 1);
  }

  const timeLeft = cutoffTime - now;
  const hours = Math.floor(timeLeft / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  const countdownElement = document.getElementById('countdown');
  if (countdownElement) {
    countdownElement.textContent = `${hours}h ${minutes}m ${seconds}s`;
  }
}

setInterval(updateCountdown, 1000);
updateCountdown(); // Initial call